import React from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import styles from '../../src/assets/styles/Header.module.scss';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'; // Ujistěte se, že cesta k AuthContext je správná
import { getApiUrl } from '../services/apiService';

// Dynamické určení URL k obrázkům
const baseUrl = getApiUrl(); // Vrátí "http://localhost:5000" nebo "https://api.mojedomena.cz"


const Header = ({ headerAbsolute = false }) => {
    const { user, logout } = useAuth(); // Přístup k informacím o uživateli a funkci pro odhlášení
    const navigate = useNavigate();

    const handleLogout = () => {
        logout(); // Volání funkce odhlášení z vašeho AuthContext
        navigate('/'); // Přesměrování uživatele na přihlašovací stránku 
    };

    return (

        <Navbar variant="dark" expand="lg" className={`${headerAbsolute ? styles.headerAbsolute : ''} ${styles.header}`}>
            <Container>
                <Navbar.Brand as={Link} to="/">
                    <img
                        src={`${baseUrl}/images/maugliherna_logo.png`}
                        width="30"
                        height="30"
                        className="d-inline-block align-top"
                        alt="Herna Mauglí logo"
                    />
                    Herna Mauglí
                </Navbar.Brand>                
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={NavLink} to="/" exact activeClassName={styles.active} className={styles.header_navLink}>Domů</Nav.Link>
                        <Nav.Link as={NavLink} to="/narozeniny" activeClassName={styles.active} className={styles.header_navLink}>Narozeniny</Nav.Link>
                        <Nav.Link as={NavLink} to="/kavarna" activeClassName={styles.active} className={styles.header_navLink}>Kavárna</Nav.Link>
                        <Nav.Link as={NavLink} to="/fotoGalerie" activeClassName={styles.active} className={styles.header_navLink}>Galerie</Nav.Link>
                        <Nav.Link as={NavLink} to="/cenik" activeClassName={styles.active} className={styles.header_navLink}>Ceník</Nav.Link>
                        <Nav.Link as={NavLink} to="/kontakt" activeClassName={styles.active} className={styles.header_navLink}>Kontakt</Nav.Link>
                        <Nav.Link as={NavLink} to="/akce" activeClassName={styles.active} className={styles.header_navLink}>Akce</Nav.Link>
                        <Nav.Link as={NavLink} to="/novinky" activeClassName={styles.active} className={styles.header_navLink}>Novinky</Nav.Link>

                    </Nav>
                    {user ? (
                        <Nav>
                            <NavDropdown title="Uživatelské menu" id="basic-nav-dropdown">
                                <NavDropdown.Item onClick={handleLogout}>Odhlásit se</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/changePassword">Změnit heslo</NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    ) : (
                        <Nav>
                            <Nav.Link as={Link} to="/login">Přihlášení</Nav.Link>
                        </Nav>
                    )}
                </Navbar.Collapse>
            </Container>
        </Navbar>

    );
};

export default Header;
